module.exports = __webpack_public_path__ + "media/customizations/regencyatesperanza/back-5a7a8cc91dd289d7df64bbfdeca61d2e.jpg";